export type { FilterChipProps } from './FilterChip'
export { FilterChip } from './FilterChip'
